import MarkdownEditor from "@uiw/react-markdown-editor";
import React from "react";
import { Card, CardBody, CardTitle } from "react-bootstrap";
import { Blog } from "../core/models/Blog";
import CategoryBadge from "./CategoryBadge";

interface BlogViewerProps {
    blog: Blog;
}

const BlogViewer: React.FC<BlogViewerProps> = ({ blog }) => {
    return <Card style={{ padding: 16 }}>
        <CardTitle>{blog.title} :: {blog.id}</CardTitle>
        <p>{blog.categories?.map(cat => <CategoryBadge cat={cat} />)}</p>
        <CardBody><MarkdownEditor.Markdown
            style={{
                fontFamily: "Ubuntu Mono",
            }}
            source={blog.markdown}
            wrapperElement={{
                "data-color-mode": "light",
            }}
        /></CardBody>
    </Card>;
}

export default BlogViewer;